__turbopack_context__.v({
  "activities_slider": "Home-module-scss-module__Sm6YZa__activities_slider",
  "activity_child": "Home-module-scss-module__Sm6YZa__activity_child",
  "attraction_sec": "Home-module-scss-module__Sm6YZa__attraction_sec",
  "banner_btn": "Home-module-scss-module__Sm6YZa__banner_btn",
  "banner_iframe_video": "Home-module-scss-module__Sm6YZa__banner_iframe_video",
  "banner_text": "Home-module-scss-module__Sm6YZa__banner_text",
  "banner_text_con": "Home-module-scss-module__Sm6YZa__banner_text_con",
  "booking_banner_ancor": "Home-module-scss-module__Sm6YZa__booking_banner_ancor",
  "closeVideo": "Home-module-scss-module__Sm6YZa__closeVideo",
  "desktop_first_banner": "Home-module-scss-module__Sm6YZa__desktop_first_banner",
  "down": "Home-module-scss-module__Sm6YZa__down",
  "explore_btn": "Home-module-scss-module__Sm6YZa__explore_btn",
  "explore_btn_mobile": "Home-module-scss-module__Sm6YZa__explore_btn_mobile",
  "helicopter_child": "Home-module-scss-module__Sm6YZa__helicopter_child",
  "helicopter_left": "Home-module-scss-module__Sm6YZa__helicopter_left",
  "helicopter_main": "Home-module-scss-module__Sm6YZa__helicopter_main",
  "helicopter_right": "Home-module-scss-module__Sm6YZa__helicopter_right",
  "highlights": "Home-module-scss-module__Sm6YZa__highlights",
  "home_banner": "Home-module-scss-module__Sm6YZa__home_banner",
  "home_booking_banner": "Home-module-scss-module__Sm6YZa__home_booking_banner",
  "image_wrapper": "Home-module-scss-module__Sm6YZa__image_wrapper",
  "metting_child": "Home-module-scss-module__Sm6YZa__metting_child",
  "mettings_main": "Home-module-scss-module__Sm6YZa__mettings_main",
  "mettings_sec": "Home-module-scss-module__Sm6YZa__mettings_sec",
  "mobile_first_banner": "Home-module-scss-module__Sm6YZa__mobile_first_banner",
  "our_rides_activities": "Home-module-scss-module__Sm6YZa__our_rides_activities",
  "our_specials": "Home-module-scss-module__Sm6YZa__our_specials",
  "our_specials_left": "Home-module-scss-module__Sm6YZa__our_specials_left",
  "our_specials_left_child": "Home-module-scss-module__Sm6YZa__our_specials_left_child",
  "our_specials_main": "Home-module-scss-module__Sm6YZa__our_specials_main",
  "our_specials_right": "Home-module-scss-module__Sm6YZa__our_specials_right",
  "pause_btn": "Home-module-scss-module__Sm6YZa__pause_btn",
  "plan_sec": "Home-module-scss-module__Sm6YZa__plan_sec",
  "plan_sec_left": "Home-module-scss-module__Sm6YZa__plan_sec_left",
  "plan_sec_right": "Home-module-scss-module__Sm6YZa__plan_sec_right",
  "privacy_policy": "Home-module-scss-module__Sm6YZa__privacy_policy",
  "restasurant_main": "Home-module-scss-module__Sm6YZa__restasurant_main",
  "restaurant_sec": "Home-module-scss-module__Sm6YZa__restaurant_sec",
  "restaurnat_left": "Home-module-scss-module__Sm6YZa__restaurnat_left",
  "restaurnat_right": "Home-module-scss-module__Sm6YZa__restaurnat_right",
  "snow_kingdom": "Home-module-scss-module__Sm6YZa__snow_kingdom",
  "snow_kingdom_left": "Home-module-scss-module__Sm6YZa__snow_kingdom_left",
  "snow_kingdom_main": "Home-module-scss-module__Sm6YZa__snow_kingdom_main",
  "snow_kingdom_mobile": "Home-module-scss-module__Sm6YZa__snow_kingdom_mobile",
  "snow_kingdom_mobile_main": "Home-module-scss-module__Sm6YZa__snow_kingdom_mobile_main",
  "snow_kingdom_right": "Home-module-scss-module__Sm6YZa__snow_kingdom_right",
  "snow_kingdom_right_content": "Home-module-scss-module__Sm6YZa__snow_kingdom_right_content",
  "stay_left": "Home-module-scss-module__Sm6YZa__stay_left",
  "stay_main": "Home-module-scss-module__Sm6YZa__stay_main",
  "stay_right": "Home-module-scss-module__Sm6YZa__stay_right",
  "stay_sec": "Home-module-scss-module__Sm6YZa__stay_sec",
  "stay_slider_child": "Home-module-scss-module__Sm6YZa__stay_slider_child",
  "store_left": "Home-module-scss-module__Sm6YZa__store_left",
  "store_main": "Home-module-scss-module__Sm6YZa__store_main",
  "store_right": "Home-module-scss-module__Sm6YZa__store_right",
  "stores_sec": "Home-module-scss-module__Sm6YZa__stores_sec",
  "summer_special_offer": "Home-module-scss-module__Sm6YZa__summer_special_offer",
  "summer_special_offer_img": "Home-module-scss-module__Sm6YZa__summer_special_offer_img",
  "summer_special_offer_img_mobile": "Home-module-scss-module__Sm6YZa__summer_special_offer_img_mobile",
});
